<template>
  <div id="TreeTable">
    <el-table
      :data="data"
      size="mini"
      @row-dblclick="rowdblclick"
      border
      style="width: 100%"
      height="300"
      :header-cell-style="{background:'#eef1f6',color:'#000'}"
    >
      <el-table-column width="80" align="center" prop="BarCode">
        <template slot="header" slot-scope="scope">
          <i
            :class="isInner?'el-icon-s-tools':'el-icon-refresh-left'"
            @click="clickIcon"
            style="color:#2594ff;font-size:18px"
          ></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column width="90" label="类型" align="center" prop="BarCode">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
            style="color:#e9cb70;font-size:18px"
          ></i>
        </template>
      </el-table-column>
      <el-table-column :prop="item.Key" :label="item.Label" width="130" align="center" :show-overflow-tooltip="true" v-for="(item,index) in configData" :key="index"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "TreeTable",
  data() {
    return {
      data: this.tableData,
      configData:this.tableConfigData,
    };
  },
  props: {
    tableData: Array,
    tableConfigData:Array,
    isInner:{
      type:Boolean,
      default:true
    },
  },
  methods: {
    //点击图标事件
    clickIcon() {
      if (!this.isInner) {
        this.$emit("clickIcon");
      }
    },
    rowdblclick(row) {
      // console.log(row);
      this.$emit("rowdblclick", row);
    }
  },
  watch: {
    tableData: {
      handler(newValue, oldValue) {
        this.data = newValue;
      },
      deep: true
    },
  },
  created() {

  },
  mounted(){
    
  }
};
</script>

<style lang="less" scoped>
#TreeTable {
  // .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  //   /*滚动条整体样式*/
  //   width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  //   height: 1px;
  // }
  // .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  //   /*滚动条里面小方块*/
  //   border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //   background: #ccc;
  // }
  // .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  //   /*滚动条里面轨道*/
  //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //   border-radius: 10px;
  //   background: #ededed;
  // }
  // .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {
  //   /*滚动条整体样式*/
  //   width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
  //   height: 10px;
  // }
  // .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {
  //   /*滚动条里面小方块*/
  //   border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //   background: #ccc;
  // }
  // .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {
  //   /*滚动条里面轨道*/
  //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //   border-radius: 10px;
  //   background: #ededed;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/Table/TreeTable/TreeTable.vue